import { jsonToFormData } from 'helpers/HelperFunctions';
import {
  discardProjectMediaUpload,
  uploadProjectMediaToS3,
} from 'helpers/projectMediaUpload';

const ADDCREDITS = 'twineApp/textProjects/ADDCREDITS';
const ADDCREDITS_SUCCESS = 'twineApp/textProjects/ADDCREDITS_SUCCESS';
const ADDCREDITS_FAIL = 'twineApp/textProjects/ADDCREDITS_FAIL';
const LOADCREDITS = 'twineApp/textProjects/LOADCREDITS';
const LOADCREDITS_SUCCESS = 'twineApp/textProjects/LOADCREDITS_SUCCESS';
const LOADCREDITS_FAIL = 'twineApp/textProjects/LOADCREDITS_FAIL';
const UPDATECREDITS = 'twineApp/textProjects/UPDATECREDITS';
const UPDATECREDITS_SUCCESS = 'twineApp/textProjects/UPDATECREDITS_SUCCESS';
const UPDATECREDITS_FAIL = 'twineApp/textProjects/UPDATECREDITS_FAIL';
const CREATEPROJECT = 'twineApp/textProjects/CREATEPROJECT';
const CREATEPROJECT_SUCCESS = 'twineApp/textProjects/CREATEPROJECT_SUCCESS';
const CREATEPROJECT_FAIL = 'twineApp/textProjects/CREATEPROJECT_FAIL';
const LOADPROJECT = 'twineApp/textProjects/LOADPROJECT';
const LOADPROJECT_SUCCESS = 'twineApp/textProjects/LOADPROJECT_SUCCESS';
const LOADPROJECT_FAIL = 'twineApp/textProjects/LOADPROJECT_FAIL';
const UPDATEPROJECT = 'twineApp/textProjects/UPDATEPROJECT';
const UPDATEPROJECT_SUCCESS = 'twineApp/textProjects/UPDATEPROJECT_SUCCESS';
const UPDATEPROJECT_FAIL = 'twineApp/textProjects/UPDATEPROJECT_FAIL';
const LOADUSERPROJECTS = 'twineApp/textProjects/LOADUSERPROJECTS';
const LOADUSERPROJECTS_SUCCESS =
  'twineApp/textProjects/LOADUSERPROJECTS_SUCCESS';
const LOADUSERPROJECTS_FAIL = 'twineApp/textProjects/LOADUSERPROJECTS_FAIL';
const DELETEPROJECT = 'twineApp/portfolio/DELETEPROJECT';
const DELETEPROJECT_SUCCESS = 'twineApp/portfolio/DELETEPROJECT';
const DELETEPROJECT_FAIL = 'twineApp/portfolio/DELETEPROJECT';
const UPLOADMEDIA = 'twineApp/textProjects/UPLOADMEDIA';
const UPLOADMEDIA_SUCCESS = 'twineApp/textProjects/UPLOADMEDIA_SUCCESS';
const UPLOADMEDIA_FAIL = 'twineApp/textProjects/UPLOADMEDIA_FAIL';
const DISCARDMEDIA = 'twineApp/textProjects/DISCARDMEDIA';
const DISCARDMEDIA_SUCCESS = 'twineApp/textProjects/DISCARDMEDIA_SUCCESS';
const DISCARDMEDIA_FAIL = 'twineApp/textProjects/DISCARDMEDIA_FAIL';

const initialState = {
  project: {},
  credits: [],
  creatingProject: false,
  createdProject: false,
  loadingProject: false,
  loadedProject: false,
  updatingProject: false,
  updatedProject: false,
  creatingCredits: false,
  createdCredits: false,
  loadingCredits: false,
  loadedCredits: false,
  updatingCredits: false,
  updatedCredits: false,
  userProjects: [],
  loadingUserProjects: false,
  loadedUserProjects: false,
  moreToLoad: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADDCREDITS:
      return {
        ...state,
        creatingCredits: true,
      };

    case ADDCREDITS_SUCCESS:
      return {
        ...state,
        credits: action.result.credits || [],
        creatingCredits: false,
        createdCredits: true,
      };

    case ADDCREDITS_FAIL:
      return {
        ...state,
        creatingCredits: false,
        createdCredits: false,
        error: action.error,
      };

    case LOADCREDITS:
      return {
        ...state,
        loadingCredits: true,
      };

    case LOADCREDITS_SUCCESS:
      return {
        ...state,
        credits: action.result.credits || [],
        loadingCredits: false,
        loadedCredits: true,
      };

    case LOADCREDITS_FAIL:
      return {
        ...state,
        loadingCredits: false,
        loadedCredits: false,
        error: action.error,
      };

    case UPDATECREDITS:
      return {
        ...state,
        updatingCredits: true,
      };

    case UPDATECREDITS_SUCCESS:
      return {
        ...state,
        credits: action.result.credits || [],
        updatingCredits: false,
        updatedCredits: true,
      };

    case UPDATECREDITS_FAIL:
      return {
        ...state,
        error: action.error,
        updatingCredits: false,
        updatedCredits: false,
      };

    case CREATEPROJECT:
      return {
        ...state,
        creatingProject: true,
      };

    case CREATEPROJECT_SUCCESS:
      return {
        ...state,
        project: action.result,
        creatingProject: false,
        createdProject: true,
      };

    case CREATEPROJECT_FAIL:
      return {
        ...state,
        error: action.error,
        creatingProject: false,
        createdProject: false,
      };

    case LOADPROJECT:
      return {
        ...state,
        loadingProject: true,
      };

    case LOADPROJECT_SUCCESS:
      return {
        ...state,
        project: action.result,
        loadingProject: false,
        loadedProject: true,
      };

    case LOADPROJECT_FAIL:
      return {
        ...state,
        error: action.error,
        loadingProject: false,
        loadedProject: false,
      };

    case UPDATEPROJECT:
      return {
        ...state,
        updatingProject: true,
      };

    case UPDATEPROJECT_SUCCESS:
      return {
        ...state,
        project: action.result,
        updatingProject: false,
        updatedProject: true,
      };

    case UPDATEPROJECT_FAIL:
      return {
        ...state,
        error: action.error,
        updatingProject: false,
        updatedProject: false,
      };

    case LOADUSERPROJECTS:
      return {
        ...state,
        loadingUserProjects: true,
      };

    case LOADUSERPROJECTS_SUCCESS:
      return {
        ...state,
        userProjects:
          action.page === 1
            ? action.result.projects || []
            : action.result.projects
            ? [...state.userProjects, ...action.result.projects]
            : state.userProjects,
        loadingUserProjects: false,
        loadedUserProjects: true,
        moreToLoad: action.result.meta
          ? action.result.meta.pagination.current_page <
            action.result.meta.pagination.total_pages
          : false,
      };

    case LOADUSERPROJECTS_FAIL:
      return {
        ...state,
        loadingUserProjects: false,
        loadedUserProjects: false,
        error: action.error,
      };

    case DELETEPROJECT:
      return { ...state };

    case DELETEPROJECT_SUCCESS:
      return { ...state };

    case DELETEPROJECT_FAIL:
      return { ...state, error: action.error };

    default:
      return state;
  }
}

export function loadProject(projectHash) {
  return {
    types: [LOADPROJECT, LOADPROJECT_SUCCESS, LOADPROJECT_FAIL],
    promise: (client) =>
      client.get(
        '/projects/' + projectHash + '?include=thumbnails,stream,credits,user'
      ),
  };
}

export function loadCredits(projectHash) {
  return {
    types: [LOADCREDITS, LOADCREDITS_SUCCESS, LOADCREDITS_FAIL],
    promise: (client) => client.get('/projects/' + projectHash + '/credits'),
  };
}

export function addCredits(projectId, user, roles) {
  return {
    types: [ADDCREDITS, ADDCREDITS_SUCCESS, ADDCREDITS_FAIL],
    promise: (client) =>
      client.post('/credits', {
        data: jsonToFormData({
          project_id: projectId,
          users: [user],
          roles: roles,
        }),
      }),
  };
}

export function updateCredits(projectId, user, roles) {
  return {
    types: [UPDATECREDITS, UPDATECREDITS_SUCCESS, UPDATECREDITS_FAIL],
    promise: (client) =>
      client.patch('/credits', {
        data: jsonToFormData({
          project_id: projectId,
          users: [user],
          roles: roles,
          _method: 'PATCH',
        }),
      }),
  };
}

export function createProject(data) {
  return {
    types: [CREATEPROJECT, CREATEPROJECT_SUCCESS, CREATEPROJECT_FAIL],
    promise: (client) =>
      client.post('/projects', {
        data,
      }),
  };
}

export function updateProject(id, data) {
  return {
    types: [UPDATEPROJECT, UPDATEPROJECT_SUCCESS, UPDATEPROJECT_FAIL],
    promise: (client) =>
      client.patch(`/projects/${id}`, {
        data,
      }),
  };
}

export function uploadProjectMedia(file, onProgress) {
  return {
    types: [UPLOADMEDIA, UPLOADMEDIA_SUCCESS, UPLOADMEDIA_FAIL],
    promise: (client) => uploadProjectMediaToS3(client, file, onProgress),
  };
}

export function discardProjectMedia(key) {
  return {
    types: [DISCARDMEDIA, DISCARDMEDIA_SUCCESS, DISCARDMEDIA_FAIL],
    promise: (client) => discardProjectMediaUpload(client, key),
  };
}

export function loadUserProjects(username, page = 1) {
  return {
    types: [LOADUSERPROJECTS, LOADUSERPROJECTS_SUCCESS, LOADUSERPROJECTS_FAIL],
    page,
    promise: (client) =>
      client.get(
        '/users/' +
          username +
          `/projects?state=live,processing&include=thumbnails&limit=12&page=${page}`
      ),
  };
}

export function deleteProject(projectId) {
  return {
    types: [DELETEPROJECT, DELETEPROJECT_SUCCESS, DELETEPROJECT_FAIL],
    promise: (client) => client.delete('/projects/' + projectId),
    // Callers show their own toast when a delete fails.
    ignoreError: true,
  };
}
